import { getTecnomUrl, getTecnomToken } from "./tecnom";
import { mapFormDataToTecnom } from "../utils/tecnomMapper";

// Función para enviar datos a Tecnóm
export const sendToTecnom = async (formData) => {
  try {
    // Normalizar el brand a mayúsculas para que coincida con la configuración
    const brand = formData.brand ? formData.brand.toUpperCase() : "GAC";

    //console.log("🔍 Debug - Brand recibido:", formData.brand);
    //console.log("🔍 Debug - Brand normalizado:", brand);

    const tecnomUrl = getTecnomUrl(brand);
    const tecnomToken = getTecnomToken(brand);

    //console.log("🔍 Debug - URL obtenida:", tecnomUrl);
    //console.log("🔍 Debug - Token obtenido:", tecnomToken ? "Sí (oculto)" : "No");

    if (!tecnomUrl || !tecnomToken) {
      console.log(`Marca ${brand} no habilitada para Tecnóm o token faltante, omitiendo envío`);
      return { message: `Marca ${brand} no habilitada para Tecnóm o token faltante` };
    }

    // Mapear los datos del formulario al formato de Tecnóm
    const tecnomData = mapFormDataToTecnom({ ...formData, brand });

    //console.log("========== ENVIANDO DATOS A TECNÓM ==========");
    //console.log("Marca:", brand);
    //console.log("URL:", tecnomUrl);
    //console.log("Datos:", JSON.stringify(tecnomData, null, 2));
    //console.log("=============================================");

    // Enviar realmente a Tecnóm
    const response = await fetch(tecnomUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Basic ${tecnomToken}`,
      },
      body: JSON.stringify(tecnomData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: "Error desconocido" }));
      console.error("❌ Error de Tecnóm:", errorData);
      throw new Error(`Error de Tecnóm: ${response.status} - ${JSON.stringify(errorData)}`);
    }

    const result = await response.json();
    console.log("✅ Respuesta exitosa de Tecnóm:", result);
    return result;
  } catch (error) {
    console.error("Error al enviar a Tecnóm:", error);
    throw error;
  }
};

